export default "__VITE_ASSET__5j0OhQz$__"